import type { BlueprintAccessibilityValueModifier } from '@/grove-blueprints/generated-types'

import type { BlueprintBindings } from '../../blueprint-bindings'
import type { ResolvedModifiers } from './resolve-modifiers'
import { resolveTextValue } from './resolve-text-value'

export function resolveAccessibilityValueModifier(
  modifier: BlueprintAccessibilityValueModifier,
  bindingValues: BlueprintBindings['bindingValues'],
  localizedString: (key: string) => string,
) {
  const attributes: ResolvedModifiers['attributes'] = {}

  attributes['aria-valuetext'] = resolveTextValue(
    modifier.value,
    localizedString,
    bindingValues,
  )

  return attributes
}
